import { AddressAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/AddressAccordion";
import { PersonalAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/PersonalAccordion";
import { ProfessionalAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/ProfessionAccordion";
import { SecurityDataAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/SecurityDataAccordion";
import { CompleteRegistrationAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/CompleteRegistrationAccordion";
import { ParametersAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/ParametersAccordion";
import { IdentifyProposalAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/IdentifyProposalAccordion";
import { ReferenceAccordion } from "@repo/core/components/layout/ProposalAccordion/variants/ReferenceAccordion";

export const ProposalAccordion = {
  Personal: PersonalAccordion,
  Address: AddressAccordion,
  Professional: ProfessionalAccordion,
  Security: SecurityDataAccordion,
  CompleteRegistration: CompleteRegistrationAccordion,
  Parameters: ParametersAccordion,
  IdentifyProposal: IdentifyProposalAccordion,
  Reference: ReferenceAccordion
};
